import React, { useState, useEffect, useRef, useCallback } from 'react';
import ReactMarkdown from 'react-markdown';

import { Button, Form } from 'react-bootstrap';
import { BsFillChatDotsFill } from 'react-icons/bs';
import '../css/Chat.css';  // Custom styles for the chat component
import '../css/ChatWindow.css';  // Custom styles for the chat component
import axios from 'axios';
import axiosInstance from '../axiosConfig';  // Import the Axios instance

import ChatButton from '../components/ChatButton';
import ChatWindow from '../components/ChatWindow';
import { Spinner } from 'react-bootstrap';



import { debounce } from 'lodash';

// ChatMessage component with memoization to prevent unnecessary re-renders
const ChatMessage = React.memo(({ msg }) => (
    <div className={`chat-message ${msg.sender}`}>
      <ReactMarkdown>{msg.text}</ReactMarkdown>
    </div>
  ));


// Custom component to handle image size
//const CustomImage = ({ src, alt }) => {
//    return <img src={src} alt={alt} style={{ maxWidth: '100%', height: 'auto' }} />;
//  };

  // Memoized CustomImage component to prevent unnecessary re-renders
const CustomImage = React.memo(({ src, alt }) => {
    return <img src={src} alt={alt} style={{ maxWidth: '100%', height: 'auto' }} />;
  });
  
//  export default CustomImage;

const Chat = ({showChat, setShowChat, messages, setMessages }) => {
  //const [showChat, setShowChat] = useState(false);
  const [chatInput, setChatInput] = useState('');
  const [loading, setLoading] = useState(false); // Track loading state

  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const maxReconnectAttempts = 10; // Limit reconnection attempts to avoid infinite loops
  const [isConnected, setIsConnected] = useState(false);



  const ws = useRef(null);  // WebSocket reference
  const token = localStorage.getItem('access_token');

  const chatBodyRef = useRef(null);

  //const baseURL = 'http://localhost:8000';  // Replace with your backend URL
  const baseURL = 'wss://present-bot.com';  // Replace with your backend URL
    //ws.current = new WebSocket(`ws://localhost:8000/ws/${session_id}`); // Use backticks for string interpolation


  const scrollToBottomIfNeeded = () => {
    if (chatBodyRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = chatBodyRef.current;
      const isAtBottom = scrollHeight - scrollTop <= clientHeight + 50; // 50px buffer
      if (isAtBottom) {
        chatBodyRef.current.scrollTop = scrollHeight;
      }
    }
  };

  const handleInputChange = useCallback((e) => {
    e.preventDefault();
    setChatInput(e.target.value);
  }, [setChatInput]);



  // Scroll to the bottom when a new message is added
  useEffect(() => {
    if (chatBodyRef.current) {
      chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
    }
    //scrollToBottomIfNeeded();


  }, [messages,showChat]);



  const handleLogin = async (recaptchaToken) => {
    try {
      // Send an empty POST request to the login endpoint
      //const response = await axios.post('http://localhost:8000/login',{recaptchaToken});
      //const response = await axios.post('http://localhost:8000/login',{captchaToken: recaptchaToken, token : localStorage.getItem('access_token')});
      //const response = await axios.post(`${baseURL}/login`,{captchaToken: recaptchaToken, token : localStorage.getItem('access_token')});

      const response = await axiosInstance.post('/login', {
        captchaToken: recaptchaToken,
        token: localStorage.getItem('access_token'),
      });
  
      
      // Assuming you get a token or session data in the response

      // Store the token or session data in localStorage
      localStorage.setItem('access_token', response.data.access_token);
      localStorage.setItem('session_id', response.data.session_id);

    } catch (error) {
      console.error('Error logging in:', error);
    }
  };


  // Toggle the chat window
  const handleChatToggle = () => {
    if (window.grecaptcha) {
        window.grecaptcha.ready(() => {
          window.grecaptcha
            .execute("6Lcy0FUqAAAAAAsQUd3aJX0k_tAu4EhFE2Ey4L16", { action: "submit" })
            .then((token) => {
              handleLogin(token);  // Use token for verification
            });
        });
      } else {
        console.error('reCAPTCHA has not been loaded');
      }
    setShowChat(!showChat);
  };



  // Connect to WebSocket when the chat opens
  const connectWebSocket22 = () => {

    if (showChat) {
      // If WebSocket already exists and is open, close it first
      //if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      if (ws.current) {
        console.log("WebSocket already connected to this session, closing it.");
        //ws.current.close();
      }

      // Open a new WebSocket connection
      const session_id = localStorage.getItem('session_id');
      //ws.current = new WebSocket('ws://localhost:8000/ws/$session_id'); // Replace with your WebSocket URL
      //ws.current = new WebSocket(`ws://localhost:8000/ws/${session_id}`); // Use backticks for string interpolation
      ws.current = new WebSocket(`${baseURL}/ws/${session_id}`);


      // Send token after WebSocket connection opens
      ws.current.onopen = () => {
        console.log('sw current', ws.current);
        console.log("WebSocket connection opened, sending token");
        ws.current.send(JSON.stringify({ token })); // Send the token to authenticate the WebSocket connection
        setIsConnected(true);
        setReconnectAttempts(0); // Reset reconnection attempts on successful connection
      };

      // Handle incoming WebSocket messages
      ws.current.onmessage = (event) => {
        const data = event.data;

        setLoading(true); // Stop spinner when DONE message is received

        if (data === 'DONEX') {
          setLoading(false); // Stop spinner when DONE message is received
        }
        
        else {
          setLoading(true); // Stop spinner when DONE message is received

        // Assume the server sends messages in chunks for streams
        setMessages((prevMessages) => {
          const lastMessageIndex = prevMessages.length - 1;

          // If the last message was from the 'assistant', append the new chunk
          if (prevMessages[lastMessageIndex] && prevMessages[lastMessageIndex].sender === 'assistant') {
            // Append the new data to the last message
            const updatedMessages = [...prevMessages];
            updatedMessages[lastMessageIndex].text += data;  // Append the chunk
            return updatedMessages;
          } else {
            // Otherwise, create a new message from the assistant
            return [...prevMessages, { text: data, sender: 'assistant' }];
          }
        });
      }
    };

        // Handle connection close
       /* 
        ws.current.onclose = (event) => {
          console.log(`WebSocket closed: ${event.reason}`);
        if (!ws.current) {
          setIsConnected(false);
    
          // Attempt to reconnect if the max reconnect attempts haven't been reached
          if (reconnectAttempts < maxReconnectAttempts && !isConnected) {
            const reconnectDelay = Math.min(5000, 1000 * Math.pow(2, reconnectAttempts)); // Exponential backoff
            console.log(`Reconnecting in ${reconnectDelay / 1000} seconds...`);
            setTimeout(() => {
              setReconnectAttempts((prevAttempts) => prevAttempts + 1);
              connectWebSocket(); // Reattempt connection
            }, reconnectDelay);
          } else {
            console.error("Max reconnection attempts reached. Giving up.");
          }
        }
        };*/
  }
}

const connectWebSocket = () => {
  if (showChat) {
      // Close existing WebSocket connection if it exists
      if (ws.current) {
          console.log("WebSocket already connected to this session, closing it.");
          // You might want to close the existing connection if needed
          // ws.current.close();
      }
        setLoading(false); // Stop spinner when DONE message is received

      // Retrieve session ID from localStorage
      const session_id = localStorage.getItem('session_id');

      // Open a new WebSocket connection with the session ID
      ws.current = new WebSocket(`${baseURL}/ws/${session_id}`);

      // Handle WebSocket open event
      ws.current.onopen = () => {
          console.log("WebSocket connection opened:", ws.current);
          // Send token for authentication
          ws.current.send(JSON.stringify({ token }));
          setIsConnected(true);  // Set connection state
          //setReconnectAttempts(0);  // Reset reconnection attempts
      };

      // Handle incoming WebSocket messages
      ws.current.onmessage = (event) => {
          const data = event.data;

          // Handle specific message types
          if (data === 'DONEX') {
              setLoading(false);  // Stop the spinner when 'DONEX' message is received
          } else {
              setLoading(true);  // Keep spinner active while receiving messages

              // Update messages with new incoming data
              setMessages((prevMessages) => {
                  const lastMessage = prevMessages[prevMessages.length - 1];

                  // If the last message is from the 'assistant', append new data to it
                  if (lastMessage && lastMessage.sender === 'assistant') {
                      const updatedMessages = [...prevMessages];
                      updatedMessages[updatedMessages.length - 1].text += data;  // Append new data to the last message
                      return updatedMessages;
                  } else {
                      // If not, create a new message from the assistant
                      return [...prevMessages, { text: data, sender: 'assistant' }];
                  }
              });
          }
      };

      // Optionally handle WebSocket close and error events
      ws.current.onclose = (event) => {
          console.log("WebSocket connection closed:", event);
          setIsConnected(false);  // Set connection state to disconnected
          // Optionally implement reconnection logic here
      };

      ws.current.onerror = (error) => {
          console.error("WebSocket error:", error);
          // Handle any errors during WebSocket communication
      };
  }
};


  useEffect(() => {
    // Establish WebSocket connection when component mounts
    connectWebSocket();


      // Cleanup WebSocket connection on component unmount or when the chat closes
      return () => {
        if (ws.current) {
          console.log("Cleaning up WebSocket connection");
          ws.current.close();
         // ws.current.onmessage = null;
        setLoading(true); // Stop spinner when DONE message is received
        }
      };
    
  }, [showChat, token]);  // Only run when `showChat` or `token` changes

  // Handle sending a message
  /*
  const handleSendMessage = (e) => {
    e.preventDefault();
    if (chatInput.trim() && ws.current) {
      // Send message via WebSocket
      ws.current.send(chatInput);
      console.log('Sent message:', chatInput);

      // Add message to local state
      setMessages((prevMessages) => [...prevMessages, { text: chatInput, sender: 'user' }]);
      setChatInput('');
    }
  };
  */

  const handleSendMessage = (localInput) => {
    if (localInput.trim() && ws.current && ws.current.readyState === WebSocket.OPEN) {
        //if (ws.current && ws.current.readyState === WebSocket.OPEN) {
      // Send message via WebSocket
      ws.current.send(localInput);
  
      // Add message to local state
      setMessages((prevMessages) => [...prevMessages, { text: localInput, sender: 'user' }]);

    }
        // Ensure the WebSocket is open before sending a message
        //if (ws.current && ws.current.readyState === WebSocket.OPEN) {
         // ws.current.send(message);
         else {
          console.error("WebSocket is not open. Cannot send message.");
        } 
  };

  return(
  <>
  <ChatButton handleChatToggle={handleChatToggle} />
  <ChatWindow
    showChat={showChat}
    messages={messages}
    chatInput={chatInput}
    chatBodyRef={chatBodyRef}
    handleInputChange={handleInputChange}
    handleSendMessage={handleSendMessage}
    handleChatToggle={handleChatToggle}
    loading={loading}
  />
</>
  );
};
export default Chat;

